export const THANKYOU = {
  TITLE: {
    EN: 'Thank you for your response.'
  },
  WHEN: {
    EN: 'when',
  },
  YOU_HAS: {
    EN: 'You has',
  },
  INVITATION: {
    EN: 'this invitation.',
  },
  COPY_RIGHT: {
    EN: 'Copyright © 2019 Vichai Trading (1983) Co. Ltd., All Right Reserved.',
  },
}
